// ConfirmEmail4PasswordResetSuccess.js

import {
    axios,
    useImperativeHandle, forwardRef, useRef, useContext, useState, useEffect,
    useSelector, useDispatch,
    useLocation, useNavigate, Link,
    AppTheme,
    mui, reducer, component, useShared,  
    replaceTabVerseListNewItem, setRead, getYearOfBirthList, localizedDateTime, verseRangeChineseName, sortResultList, canPushNewEntry, Highlight, resetSelectedAll, getBookChapterVerseChineseName, getChapterChineseName, getBookChapterChineseName, getTabLabel,
    VERSION, COUNTRY_LIST, MAX_LENGTH_SEARCH_STRING, MAX_LENGTH_NOTE_CONTENT, MAX_LENGTH_NOTE_TITLE, SPACE, API_BASE_URL, MAX_LENGTH_NON_SEARCH_STRING1, MAX_LENGTH_NON_SEARCH_STRING2,
    homeContext, searchContext, noteContext,
} from '../Utilities/sharedHeader';

const { styled, Card, Stack } = mui;

const CustomCard = styled(Card)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  maxWidth: '450px',
  padding: `${theme.spacing(4)} ${theme.spacing(1)}`, // Top-bottom: XXpx, Left-right: YYpx
  gap: theme.spacing(2),
  margin: 'auto',
  boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  [theme.breakpoints.up('sm')]: {
    width: '450px',
  },
  ...theme.applyStyles('dark', {
    boxShadow:
      'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  }),
}));

const SignUpContainer = styled(Stack)(({ theme }) => ({
  height: 'calc((1 - var(--template-frame-height, 0)) * 120dvh)',
  minHeight: '100%',
  padding: theme.spacing(2),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4),
  },
  '&::before': {
    content: '""',
    display: 'block',
    position: 'absolute',
    zIndex: -1,
    inset: 0,
    backgroundImage:
      'radial-gradient(ellipse at 50% 50%, hsl(210, 100%, 97%), hsl(0, 0%, 100%))',
    backgroundRepeat: 'no-repeat',
    ...theme.applyStyles('dark', {
      backgroundImage:
        'radial-gradient(at 50% 50%, hsla(210, 100%, 16%, 0.5), hsl(220, 30%, 5%))',
    }),
  },
}));

export default function ConfirmEmail4PasswordResetSuccess(props){

    const location = useLocation();
    const { email } = location.state || {}; // Access the passed data

    const { Slider, Snackbar, styled, grey, Grid, Chip, Divider, Tab, Tabs, Box, Accordion, AccordionSummary, AccordionDetails, ListItemIcon, List, ListItem, ListItemText, TextField, IconButton, InputBase, Paper, Alert, Select, FormControl, FormControlLabel, FormLabel, FormGroup, MenuItem, Container, Typography, ButtonGroup, Button, Stack, Fab, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Radio, RadioGroup, AppBar, Toolbar, Table, TableContainer, TableBody, TableRow, TableCell, CardMedia, CardContent, CssBaseline, FormHelperText, Switch, Card, CheckIcon, ClearIcon, DeleteIcon, CloseIcon, ExpandMoreIcon, VisibilityOutlinedIcon, KeyboardArrowUpIcon, KeyboardDoubleArrowUpIcon, HistoryIcon, StickyNote2Icon, NoteAddIcon, SearchIcon, DescriptionIcon, EditDocumentIcon, ImportContactsIcon, WestIcon, EastIcon, HomeIcon, PersonIcon, LogoutIcon, PlagiarismIcon, DeviceThermostatIcon, FileCopyIcon, LocalOfferIcon, InfoIcon } = mui;
    const { setButtonTextDialog4, setButtonText, setDialogTitle, setBookReadLogToBeCleared, setCallerConfirmationDialog, setCaller4NoteBookmarkList, setNoteSearchString, setConfirmedNoteSearchString, setNoteSearchStringClearButton, setShowRemainingNoteSearch, setSearchCriteriaListItem2, setSearchResultVerseList2, setPageNumberNoteSearch, setVerseListItem2, setNoteSearchStringPlaceHolder, reset4NoteSearch, setTabVerseListNew, reset4SignIn, setTitleToBeDeleted, reset4ConfirmationDialog, reset4GoToTopButtonVisible, reset4NoteBookmarkList, reset4Dialog4, reset4NoteBookmarkVerseList, reset4ChipArray, reset4verseLabelArrows4Result, reset4Switch1, reset4Dialog2, reset4Search, reset4Verse, reset4Chapter, reset4Book, reset4Home, setGoToTopButtonVisible, setVerseListItem, setNonSearchString1PlaceHolder, setNonSearchString2PlaceHolder, setSearchStringPlaceHolder, setSearchString, setShowLeftArrowVerseSearch, setShowRightArrowVerseSearch, setShowfabContentVerseSearch, setShowLeftArrowNote, setShowRightArrowNote, setShowfabContentNote, setShowLeftArrowNoteSearch, setShowRightArrowNoteSearch, setShowfabContentNoteSearch, setSearchCriteriaListItem, setPageNumberVerseSearch, setOpenConfirmationDialog, setOpen3, setConfirmedTabNumber, setOpen2, setPageNumberNote, setDetails, setLengthIndicator4Details, setLengthIndicator4Title, setLoading, setHistoryList, setHistoryListItemSelected, setHistoryBookChapter, setNoteBookmarkList, setNoteBookmarkListBookChapterVerse, setConfirmedSearchString, setNonSearchString1, setNonSearchString2, setSearchStringClearButton, setNonSearchStringClearButton, setSearchScopeList, setSearchScopeListItemSelected, setChipData, setShowRemaining, setSearchResultVerseList, setSearchHttpPostData, setBookChapterList, setBookChapterListItemSelected, setOpen1, setBookListItemSelected, setSearchCriteria, setUserListItem, setVerseReadLogList4Book, setSearchTabNumber, setBookChapter, setBookList, setTitle, setTitleClearButton, setBook4Accordion1, setChapter4Accordion1, setVerse4Accordion1, setBookChapter2, setBookChapterList2, setVerseList4Accordion1, setNoteBookmarkVerseList, setNoteBookmarkListItemToBeDeleted, setNoteBookmarkListItemToBeChanged, setTab4AddChange, setViewArea, setCredential, setCircularProgressText, setEmailExisted, setUsernameExisted, setLastNameOverMaxLength, setFirstNameOverMaxLength, reset4Profile } = reducer;
    const { SignUpEmailSent, Profile4System, Profile4Personal, History, AddChangeNote, FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, VerseSearch, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem } = component;  
    const { getTempCredential, passwordReset, sendEmail4PasswordReset, getEmailByUsername, postUserListItem, bookRead, deleteVerseReadLogList, getNoteBookmarkList3, deleteLogListItem, getToken, postLogListItem, postPutSearchCriteriaListItem, deleteVerseReadLogListItem, postPutVerseReadLogListItem, postHistoryListItem, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, getVerseReadLogList4Book, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem } = useShared();

    const [password, setPassword] = useState('');
    const [passwordError, setPasswordError] = useState(false);
    const [passwordErrorMessage, setPasswordErrorMessage] = useState('');

    const [passwordRetype, setPasswordRetype] = useState('');
    const [passwordRetypeError, setPasswordRetypeError] = useState(false);
    const [passwordRetypeErrorMessage, setPasswordRetypeErrorMessage] = useState('');    

    const [passwordResetMessage, setPasswordResetMessage] = useState('');   

    const [passwordDisabled, setPasswordDisabled] = useState(false);
    const [passwordRetypeDisabled, setPasswordRetypeDisabled] = useState(false);
    const [checkDisplayed, setCheckDisplayed] = useState(true);

    const [loading4Home, setLoading4Home] = useState(false);

    const handleOnClickSave = async (event) => {

        event.preventDefault();

        const passed = await validateInputs();

        if (passed) {

            setLoading4Home(true);

            const tempCredential = await getTempCredential();

            if (tempCredential) {
                const item = {
                    Credential: tempCredential,
                    Email: email,
                    Password: password,
                    Updated: { 
                        Password: true,
                    }
                };      
                await passwordReset(item, 'ConfirmEmail4PasswordResetSuccess');
                setPasswordResetMessage('重設密碼完成');
                setPasswordDisabled(true);
                setPasswordRetypeDisabled(true);
                setCheckDisplayed(false);
                setLoading4Home(false);      
            }
            else {
                setLoading4Home(false);     
            }

            // getToken('tempToken', 'eyJhbGciOiJIUzI1NiIsInR5c', 5)
            // .then(async (token) => {
            //     if (token.length > 0) {
            //         const tempCredential = {
            //             UserName: 'tempToken',
            //             Token: token
            //         };
            //         const item = {
            //             Credential: tempCredential,
            //             Email: email,
            //             Password: password,
            //             Updated: { 
            //                 Password: true,
            //             }
            //         };      
            //         await passwordReset(item, 'ConfirmEmail4PasswordResetSuccess');
            //         setPasswordResetMessage('重設密碼完成');
            //         setPasswordDisabled(true);
            //         setPasswordRetypeDisabled(true);
            //         setCheckDisplayed(false);

            //         setLoading4Home(false);      
            //     }
            // })   
                     
        }

    }

    const validateInputs = async () => {

        let isValid = true;

        let passwordOK = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/.test(password);
        if (!password || password.length === 0) {
            setPasswordError(true);
            setPasswordErrorMessage('需要輸入密碼');
            isValid = false;             
        } else if (!passwordOK) {
            setPasswordError(true);
            setPasswordErrorMessage('密碼組合錯誤，請重新輸入');
            isValid = false;      
        } else {
            setPasswordError(false);
            setPasswordErrorMessage('');
            if (passwordRetype !== password) {
                setPasswordRetypeError(true);
                setPasswordRetypeErrorMessage('兩組密碼不符，請重新輸入');
                isValid = false;      
            } else {
                setPasswordRetypeError(false);
                setPasswordRetypeErrorMessage('');
            }   
        }     

        return isValid;

    }   

    const handleOnChangePassword = (e) => {
        setPasswordResetMessage('');
        let value = e.target.value;
        if (value.length <= 50) {
            setPassword(value);
            setPasswordError(false);
            setPasswordErrorMessage('');
        } else {
            setPasswordError(true);
            setPasswordErrorMessage('最長 50 個字串');
        }  
    }

    const handleOnChangePassworddRetype = (e) => {
        setPasswordResetMessage('');
        let value = e.target.value;
        if (value.length <= 50) {
            setPasswordRetype(value);
            setPasswordRetypeError(false);
            setPasswordRetypeErrorMessage('');
        } else {
            setPasswordRetypeError(true);
            setPasswordRetypeErrorMessage('最長 50 個字串');
        }  
    }

    return (
        
        <AppTheme {...props}>

        <CssBaseline enableColorScheme />

            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-start', height: '75vh', overflowY: 'auto' }}>

                <SignUpContainer direction="column">

                    <CustomCard variant="outlined">

                        <Typography gutterBottom variant="h5" component="div" sx={{ paddingLeft: 2 }}>
                        重設密碼
                        </Typography>

                        <Box sx={{ padding: 2 }}>

                            <FormControl fullWidth>
                                <FormLabel>新密碼 (組合至少 8 個字元，包括大小寫字母、數字和符號)</FormLabel>
                                <TextField
                                    required
                                    fullWidth
                                    name='Password'
                                    type='password'
                                    error={passwordError}
                                    value={password}
                                    onChange={handleOnChangePassword}    
                                    sx={{
                                        height: 40, // Sets the height of the TextField container
                                        '& .MuiInputBase-root': {
                                        height: '100%', // Ensures the input matches the container height
                                        },
                                    }}     
                                    disabled={passwordDisabled}
                                />
                                {passwordError && (
                                <FormHelperText sx={{ color: 'error.main' }}>
                                    {passwordErrorMessage}
                                </FormHelperText>
                                )}           
                            </FormControl>                                    

                            <FormControl fullWidth sx={{ paddingTop: '10px' }}>
                                <FormLabel>確認新密碼</FormLabel>
                                <TextField
                                    required
                                    fullWidth
                                    name='PasswordRetype'
                                    type='password'
                                    error={passwordRetypeError}
                                    value={passwordRetype}
                                    onChange={handleOnChangePassworddRetype}    
                                    sx={{
                                        height: 40, // Sets the height of the TextField container
                                        '& .MuiInputBase-root': {
                                        height: '100%', // Ensures the input matches the container height
                                        },
                                    }}   
                                    disabled={passwordRetypeDisabled}                                
                                />
                                {passwordRetypeError && (
                                <FormHelperText sx={{ color: 'error.main' }}>
                                    {passwordRetypeErrorMessage}
                                </FormHelperText>
                                )}           
                            </FormControl>

                            {checkDisplayed &&
                            <Grid size={12} sx={{ paddingTop: '50px', paddingBottom: '0px', alignItems: 'center' }}>
                                <IconButton
                                    sx={{
                                    borderRadius: 1,
                                    bgcolor: 'primary.main',
                                    '&:hover': { bgcolor: 'primary.main' },
                                    width: '100%',
                                    }}
                                    onClick={handleOnClickSave}
                                >
                                    <CheckIcon sx={{ color: 'white' }} />
                                </IconButton>   
                            </Grid>                             
                            }

                            <Typography gutterBottom variant="h5" component="div" sx={{ padding: 2, textAlign: 'center' }}>
                            {passwordResetMessage}
                            </Typography>                            

                        </Box>

                        <Box sx={{ paddingTop: '100px', display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <Typography sx={{ textAlign: 'center' }}>
                            <Link
                                to='/signin'
                                variant='body2'
                                sx={{ alignSelf: 'center' }}
                            >
                                登入頁面
                            </Link>
                            </Typography>
                        </Box>   

                    </CustomCard>

                </SignUpContainer>

            {loading4Home && <ClipLoader1 />}

            </div>

        </AppTheme>

    );
}